import React from 'react';
import PropTypes from 'prop-types';
import { formatDate, formatDateToWord } from 'helpers/utils';

// Timestamp of a topic or response: the exact date answers "when exactly",
// the relative part answers "how long ago" — readers of a discussion want both.
//   17-Sep-2026 10:42 · 22 hours ago
const InteractionTime = ({ date, fallback = '', className = '' }) => {
  const exact = formatDate(date, 'dd-MMM-yyyy HH:mm');
  if (!exact) return fallback ? <span className={className}>{fallback}</span> : null;

  const ago = formatDateToWord(date);

  return (
    <span className={className}>
      {exact}
      {ago && <span className="tw-text-slate-400"> · {ago}</span>}
    </span>
  );
};

InteractionTime.propTypes = {
  date: PropTypes.string,
  fallback: PropTypes.string,
  className: PropTypes.string,
};

export default InteractionTime;
